"use client";

import { useQuery } from "@tanstack/react-query";

import { fetchBillingConfig } from "@/lib/billing-api-client";
import type { BillingConfig } from "@/types/billing";
import { billingKeys } from "@/lib/query/billing-keys";

/**
 * Whether the install has a billing provider configured
 * (`GET /api/billing/config`). Every billing surface (login sign-up control,
 * onboarding plan step, admin Billing nav, org subscription section) gates on
 * `enabled`. A 404 or a failed request both resolve to "disabled": billing
 * surfaces hide, they never error.
 */
export function useBillingConfig() {
  const query = useQuery({
    queryKey: billingKeys.config(),
    queryFn: fetchBillingConfig,
    staleTime: 5 * 60_000,
    retry: false,
  });

  const config: BillingConfig | undefined = query.data;
  return {
    config,
    enabled: config?.enabled === true,
    signupEnabled: config?.signupEnabled === true,
    /** True until the first answer arrives. Render nothing billing-related meanwhile. */
    isPending: query.isPending,
    isError: query.isError,
  };
}
